import(/* webpackMode: "eager", webpackExports: ["PaginatedGallery"] */ "/vercel/path0/components/paginated-gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsSection"] */ "/vercel/path0/components/testimonials-section.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
